import { __assign, __rest } from "tslib";
import React from 'react';
import VeltRecorderControlPanelCollapsedButtonOffWireframe from './VeltRecorderControlPanelCollapsedButtonOffWireframe/VeltRecorderControlPanelCollapsedButtonOffWireframe';
import VeltRecorderControlPanelCollapsedButtonOnWireframe from './VeltRecorderControlPanelCollapsedButtonOnWireframe/VeltRecorderControlPanelCollapsedButtonOnWireframe';
import { transformWireframeProps } from '../../../utils/propUtils';
var VeltRecorderControlPanelCollapsedButtonWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-recorder-control-panel-collapsed-button-wireframe", __assign({}, transformedProps), children));
};
VeltRecorderControlPanelCollapsedButtonWireframe.On = VeltRecorderControlPanelCollapsedButtonOnWireframe;
VeltRecorderControlPanelCollapsedButtonWireframe.Off = VeltRecorderControlPanelCollapsedButtonOffWireframe;
export default VeltRecorderControlPanelCollapsedButtonWireframe;
